import {
  PerformanceCardButtons,
} from '../component/fund-performances/pojo/PerformanceCardButtons';
import { FpSelected } from '../component/fund-performances/fp-value-creation/fp-value-creation.component';
import { FundPerformance } from '../dto/FundPerformance';

export class FpService {
  static setTvpi(fp: FundPerformance): void {
    if (!fp) {
      return;
    }

    const contribution = fp.contribution || 0;
    const distribution = fp.distribution || 0;
    const carryDistribution = fp.carryDistribution || 0;
    const totalFmv = Math.round(fp.totalFmv || 0);
    const totalCost = Math.round(fp.totalCost || 0);
    const totalExpenses = Math.abs(Math.round(fp.totalExpenses || 0));

    const navBeforeCarry = contribution + distribution + carryDistribution + (totalFmv - totalCost - totalExpenses);

    fp.tvpi = 0;
    if (contribution !== 0) {
      fp.tvpi = (navBeforeCarry + distribution) / contribution;
    }
  }

  static setDefaultIrrTotals(fundPerformances: FundPerformance[]): void {
    if (!fundPerformances?.length) {
      return;
    }

    fundPerformances.forEach((fundPerformance) => {
      fundPerformance.activeIrr ||= 0;
      fundPerformance.realizedIrr ||= 0;
      fundPerformance.calculatedGrossIrr ||= 0;
    });
  }

  static updatePortfolioPerformanceCard(ppCard: PerformanceCardButtons, selectedFp: FundPerformance): void {
    if (!ppCard || !selectedFp) {
      return;
    }

    const { isRealized, isUnrealized } = ppCard;
    const { realizedCompaniesAmount, activeCompaniesAmount } = selectedFp;

    if ((isRealized && !realizedCompaniesAmount) || (isUnrealized && !activeCompaniesAmount)) {
      ppCard.isTotal = true;
      ppCard.isUnrealized = false;
      ppCard.isRealized = false;
    }
  }

  static updateSelectedAfterNewPeriod(period: Date, selected: FpSelected, deleteText: string[]): void {
    if (!period) {
      selected.period = undefined;
      selected.fp = undefined;
      return;
    }
    if (period !== selected.period) {
      selected.period = period;
      deleteText.length = 0; // clear any existing entries
      deleteText.push(
        'Period ' + selected.period.toString() + ' will be deleted',
        'Everyone in this fund will lose this period and related data',
        'This can not be undone',
      );
    }
  }

  static isCarryAbsent(fp: FundPerformance): boolean {
    return (fp.carryInterestPercent === null || fp.carryInterestPercent === undefined)
      && (fp.carryInterest === null || fp.carryInterest === undefined);
  }

  static fillCarryInterestPct(fundPerformanceForUpdate: FundPerformance, fundPerformances: FundPerformance[]): void {
    const lastNonNullCarryInterestPercent = fundPerformances
      .sort((a, b) => new Date(b.period).getTime() - new Date(a.period).getTime())
      .find((fp) => fp.carryInterestPercent !== null && fp.period < fundPerformanceForUpdate.period)?.carryInterestPercent;
    fundPerformanceForUpdate.carryInterestPercent = lastNonNullCarryInterestPercent || null;
  }
}
